import React from 'react';
import { Link } from 'react-router-dom';

import { Box, Typography, Button, CardMedia } from '@mui/material';

import LoginForm from '../../components/LoginForm';
import localization from '../../localization';
import parentPaths from '../../services/paths';

import Logo from '../../assets/NexwayLogo425x120.png';

import './AuthScreen.scss';

const AuthScreen = () => {
  const realm = parentPaths.config.currentRealm;

  return (
    <Box display="flex" flexDirection="column" alignItems="center" maxWidth="424px">
      <Box>
        <CardMedia
          image={Logo}
          className="image"
        />
        <Typography
          variant="subtitle1"
          color="textPrimary"
          style={{ fontFamily: 'Roboto, sans-serif' }}
        >
          {localization.t('forms.subHeaders.through')}
          {localization.t('forms.subHeaders.loginWelcomSubHeader')}
        </Typography>
      </Box>
      <Box maxWidth="md" className="loginContainer">
        <Box className="headerSignIn" mt={6}>
          <Typography variant="h3">
            {localization.t('forms.headers.signIn')}
          </Typography>

          {false && (
            <Typography variant="subtitle2" color="secondary">
              {localization.t('forms.text.signInSso')}
            </Typography>
          )}
        </Box>

        {false && (
          <Box mt={2}>
            <Button
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              className="loginButton"
            >
              {localization.t('forms.buttons.googleLogin')}
            </Button>
          </Box>
        )}

        {false && (
          <Typography
            variant="subtitle2"
            color="secondary"
            align="center"
            className="orLogin"
          >
            {localization.t('forms.text.loginWithEmailAddress')}
          </Typography>
        )}

        <LoginForm />

        <Box className="signUpContainer" justifyContent='flex-end'>
          <Link
            to={`${realm}/recover-password`}
            color="text.secondary"
            className="forgotPasswordLink"
          >
            {localization.t('forms.text.forgotPassword')}
          </Link>
        </Box>

        {false && (
          <Box className="signUpContainer">
            <Typography color="textPrimary">
              {localization.t('forms.text.dontHaveAccount')}
            </Typography>

            <Link
              to="/register"
              color="primary"
              className="signUpLink"
            >
              {localization.t('forms.links.signUp')}
            </Link>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AuthScreen;
